document.addEventListener("DOMContentLoaded", () => {

document.querySelectorAll(".essntl-scent-circle").forEach(card=>{

const rating=Number(card.dataset.rating);

const imageUrl=card.dataset.image;
const canvas=card.querySelector("canvas");

const ctx=canvas.getContext("2d");

const img=new Image();

img.crossOrigin="anonymous";

img.onload=function(){

    console.log("Loaded:", imageUrl);

const size = canvas.width;
const cx = size / 2;
const cy = size / 2;
const r = size / 2 - 4;

const angle=rating/5*Math.PI*2;

ctx.clearRect(0,0,size,size);

ctx.save();

ctx.beginPath();

ctx.arc(cx,cy,r,0,Math.PI*2);

ctx.clip();

ctx.filter="grayscale(80%)";

ctx.drawImage(img,0,0,size,size);

ctx.restore();

ctx.save();

ctx.beginPath();

ctx.moveTo(cx,cy);

ctx.arc(
cx,
cy,
r,
-Math.PI/2,
angle-Math.PI/2
);

ctx.closePath();

ctx.clip();

ctx.filter="none";

ctx.drawImage(img,0,0,size,size);

ctx.restore();

ctx.beginPath();

ctx.lineWidth=4;
ctx.strokeStyle="#ece7df";

ctx.arc(cx,cy,r,0,Math.PI*2);

ctx.stroke();

ctx.beginPath();

ctx.lineWidth=6;
const ringColor = card.dataset.color || "#b78a3d";

ctx.strokeStyle = ringColor;
ctx.lineCap="round";

ctx.arc(
cx,
cy,
r,
-Math.PI/2,
angle-Math.PI/2
);

ctx.stroke();

};

img.onerror = function () {

    console.error("Failed:", imageUrl);

};

img.src=imageUrl;

});

});